function injectStyle (ssrContext) {
  require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3e37b43c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector?type=styles&index=0!./table.vue")
}
var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./table.vue"),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/table/table.vue
// module id = 228
// module chunks = 1